import type { GetMeQuery } from 'generated/graphql';
import { useCurrentUserQueryContext } from './CurrentUserQueryContext';

/**
 * NOTE: uses Suspense, make sure to handle it accordingly
 */
export function useCurrentUser(): GetMeQuery {
  return readCentralizedCurrentUser(useCurrentUserQueryContext());
}

export function readCentralizedCurrentUser({
  query,
  suspensePromise,
}: ReturnType<typeof useCurrentUserQueryContext>): GetMeQuery {
  if (query.error != null) throw query.error;
  if (query.data == null && suspensePromise != null) throw suspensePromise;
  if (query.data == null) throw new Error('getMe completed without data');

  return query.data;
}
